 
 if($('.video_slider').length > 0){
   
        	$('.video_slider').slick({
              slidesToShow:3,
        		slidesToScroll: 1,
        		dots: false,    		
        		speed: 1000,        
    			// appendArrows: ".slider-arrows-dots",
    			  arrows: false,
    			 arrows: true,
    			 prevArrow: '<div title="Previous" class="custom-left  slider_change_img custom-arrow trans"><svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.5303 0.307561C8.82319 0.600454 8.82319 1.07533 8.5303 1.36822L2.0103 7.88822C1.53319 8.36533 1.53319 9.15045 2.0103 9.62756L8.5303 16.1476C8.82319 16.4405 8.82319 16.9153 8.5303 17.2082C8.2374 17.5011 7.76253 17.5011 7.46964 17.2082L0.949636 10.6882C-0.113257 9.62533 -0.113258 7.89045 0.949636 6.82756L7.46964 0.307561C7.76253 0.0146673 8.2374 0.0146673 8.5303 0.307561Z" fill="#E71E8C"/></svg></div>',
    			 nextArrow: '<div title="Next" class="custom-right  slider_change_img custom-arrow trans"><svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.379582 0.307561C0.672475 0.0146673 1.14735 0.0146673 1.44024 0.307561L7.96024 6.82756C9.02314 7.89045 9.02314 9.62533 7.96024 10.6882L1.44024 17.2082C1.14735 17.5011 0.672475 17.5011 0.379582 17.2082C0.0866888 16.9153 0.0866888 16.4405 0.379582 16.1476L6.89958 9.62756C7.37669 9.15045 7.37669 8.36533 6.89958 7.88822L0.379582 1.36822C0.0866888 1.07533 0.0866888 0.600454 0.379582 0.307561Z" fill="#E71E8C"/></svg></div>', 
    			autoplay: false,
              infinite: true,
    			autoplaySpeed: 1500,
                responsive: [
                     
                    {
                        breakpoint:768,
                        settings: {
                          slidesToShow: 2,
                          slidesToScroll:2,
                          infinite: true,
                          dots: false
                        }
                      },
                    {
                        breakpoint:566,
                        settings: {
                          slidesToShow: 2,
                          slidesToScroll:2,
                          infinite: true,
                          dots: false
                        }
                      },
                    {
                        breakpoint:479,
                        settings: {
                          slidesToShow: 1,
                          slidesToScroll:1,
                          infinite: true,
                          dots: false
                        }
                      }
                ]
            });
 

 }


 
 if($('.featued_logo').length > 0){
        	$('.featued_logo').slick({
              slidesToShow:5,
        		slidesToScroll: 3,
        		dots: true,    		
        		speed: 1000,        
    			// appendArrows: ".slider-arrows-dots",
    			  arrows: false,
    			// prevArrow: '<div title="Previous" class="custom-left custom-arrow trans"><svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2L14 12L2 22" stroke="currentColor" troke-width="4"/></svg></div>',
    			// nextArrow: '<div title="Next" class="custom-right custom-arrow trans"><svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2L14 12L2 22" stroke="currentColor" troke-width="4"/></svg></div>', 
    			autoplay: false,
              infinite: true,
    			autoplaySpeed: 1500,
                responsive: [
                      {
                        breakpoint:1200,
                        settings: {
                          slidesToShow: 4,
                          slidesToScroll:2,
                          infinite: true,
                          dots: true
                        }
                      },
                    {
                        breakpoint:768,
                        settings: {
                          slidesToShow: 3,
                          slidesToScroll:2,
                          infinite: true,
                          dots: true
                        }
                      },
                    {
                        breakpoint:566,
                        settings: {
                          slidesToShow: 2,
                          slidesToScroll:2,
                          infinite: true,
                          dots: true
                        }
                      }
                ]
            });
    }
 

 if($('.community_slide').length > 0){
          $('.community_slide').slick({
                slidesToShow:5,
        		slidesToScroll: 1,
        		dots: false,    		
        		speed: 1000,        
    			// appendArrows: ".slider-arrows-dots",
    			 arrows: true,
    				 prevArrow: '<div title="Previous" class="custom-left custom-arrow trans"><svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.5303 0.307561C8.82319 0.600454 8.82319 1.07533 8.5303 1.36822L2.0103 7.88822C1.53319 8.36533 1.53319 9.15045 2.0103 9.62756L8.5303 16.1476C8.82319 16.4405 8.82319 16.9153 8.5303 17.2082C8.2374 17.5011 7.76253 17.5011 7.46964 17.2082L0.949636 10.6882C-0.113257 9.62533 -0.113258 7.89045 0.949636 6.82756L7.46964 0.307561C7.76253 0.0146673 8.2374 0.0146673 8.5303 0.307561Z" fill="#E71E8C"/></svg></div>',
    			 nextArrow: '<div title="Next" class="custom-right custom-arrow trans"><svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.379582 0.307561C0.672475 0.0146673 1.14735 0.0146673 1.44024 0.307561L7.96024 6.82756C9.02314 7.89045 9.02314 9.62533 7.96024 10.6882L1.44024 17.2082C1.14735 17.5011 0.672475 17.5011 0.379582 17.2082C0.0866888 16.9153 0.0866888 16.4405 0.379582 16.1476L6.89958 9.62756C7.37669 9.15045 7.37669 8.36533 6.89958 7.88822L0.379582 1.36822C0.0866888 1.07533 0.0866888 0.600454 0.379582 0.307561Z" fill="#E71E8C"/></svg></div>', 
    		autoplay: false,
                infinite: true,
    			autoplaySpeed: 3000,
            responsive: [
                    {
                      breakpoint: 1200,
                      settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                      }
                    },
                {
                      breakpoint: 768,
                      settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                      }
                    },
                {
                      breakpoint: 480,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                      }
                    },
                {
                      breakpoint: 400,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                      }
                    }
              ]
            });

 }




 if($('.main-slider_combo').length > 0){
        	$('.main-slider_combo').slick({
              slidesToShow:1,
        		slidesToScroll: 1,
        		dots: false,    		
        		speed: 1000,        
    			// appendArrows: ".slider-arrows-dots",
    			  arrows: true,
    			 prevArrow: '<div title="Previous" class="custom-left custom-arrow trans"><svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.5303 0.307561C8.82319 0.600454 8.82319 1.07533 8.5303 1.36822L2.0103 7.88822C1.53319 8.36533 1.53319 9.15045 2.0103 9.62756L8.5303 16.1476C8.82319 16.4405 8.82319 16.9153 8.5303 17.2082C8.2374 17.5011 7.76253 17.5011 7.46964 17.2082L0.949636 10.6882C-0.113257 9.62533 -0.113258 7.89045 0.949636 6.82756L7.46964 0.307561C7.76253 0.0146673 8.2374 0.0146673 8.5303 0.307561Z" fill="#E71E8C"/></svg></div>',
    			 nextArrow: '<div title="Next" class="custom-right custom-arrow trans"><svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.379582 0.307561C0.672475 0.0146673 1.14735 0.0146673 1.44024 0.307561L7.96024 6.82756C9.02314 7.89045 9.02314 9.62533 7.96024 10.6882L1.44024 17.2082C1.14735 17.5011 0.672475 17.5011 0.379582 17.2082C0.0866888 16.9153 0.0866888 16.4405 0.379582 16.1476L6.89958 9.62756C7.37669 9.15045 7.37669 8.36533 6.89958 7.88822L0.379582 1.36822C0.0866888 1.07533 0.0866888 0.600454 0.379582 0.307561Z" fill="#E71E8C"/></svg></div>', 
    			autoplay: false,
                infinite: true,
    			autoplaySpeed: 3000
            });
    }


 if($('.testimonial_slider').length > 0){
        	$('.testimonial_slider').slick({
              slidesToShow:1,
        		slidesToScroll: 1,
        		dots: true,    		
        		speed: 1000,        
    			// appendArrows: ".slider-arrows-dots",
    			  arrows: false,
    			 prevArrow: '<div title="Previous" class="custom-left custom-arrow trans"><svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.5303 0.307561C8.82319 0.600454 8.82319 1.07533 8.5303 1.36822L2.0103 7.88822C1.53319 8.36533 1.53319 9.15045 2.0103 9.62756L8.5303 16.1476C8.82319 16.4405 8.82319 16.9153 8.5303 17.2082C8.2374 17.5011 7.76253 17.5011 7.46964 17.2082L0.949636 10.6882C-0.113257 9.62533 -0.113258 7.89045 0.949636 6.82756L7.46964 0.307561C7.76253 0.0146673 8.2374 0.0146673 8.5303 0.307561Z" fill="#E71E8C"/></svg></div>',
    			 nextArrow: '<div title="Next" class="custom-right custom-arrow trans"><svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.379582 0.307561C0.672475 0.0146673 1.14735 0.0146673 1.44024 0.307561L7.96024 6.82756C9.02314 7.89045 9.02314 9.62533 7.96024 10.6882L1.44024 17.2082C1.14735 17.5011 0.672475 17.5011 0.379582 17.2082C0.0866888 16.9153 0.0866888 16.4405 0.379582 16.1476L6.89958 9.62756C7.37669 9.15045 7.37669 8.36533 6.89958 7.88822L0.379582 1.36822C0.0866888 1.07533 0.0866888 0.600454 0.379582 0.307561Z" fill="#E71E8C"/></svg></div>', 
    			autoplay: false,
                infinite: true,
    			autoplaySpeed: 3000
            });
    }



 if($('.product_slider_home').length > 0){
          $('.product_slider_home').slick({
                slidesToShow:4,
        		slidesToScroll: 1,
        		dots: false,    		
        		speed: 1000,        
    			// appendArrows: ".slider-arrows-dots",
    			 arrows: true,
    			 prevArrow: '<div title="Previous" class="custom-left custom-arrow trans"><svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.5303 0.307561C8.82319 0.600454 8.82319 1.07533 8.5303 1.36822L2.0103 7.88822C1.53319 8.36533 1.53319 9.15045 2.0103 9.62756L8.5303 16.1476C8.82319 16.4405 8.82319 16.9153 8.5303 17.2082C8.2374 17.5011 7.76253 17.5011 7.46964 17.2082L0.949636 10.6882C-0.113257 9.62533 -0.113258 7.89045 0.949636 6.82756L7.46964 0.307561C7.76253 0.0146673 8.2374 0.0146673 8.5303 0.307561Z" fill="#E71E8C"/></svg></div>',
    			 nextArrow: '<div title="Next" class="custom-right custom-arrow trans"><svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.379582 0.307561C0.672475 0.0146673 1.14735 0.0146673 1.44024 0.307561L7.96024 6.82756C9.02314 7.89045 9.02314 9.62533 7.96024 10.6882L1.44024 17.2082C1.14735 17.5011 0.672475 17.5011 0.379582 17.2082C0.0866888 16.9153 0.0866888 16.4405 0.379582 16.1476L6.89958 9.62756C7.37669 9.15045 7.37669 8.36533 6.89958 7.88822L0.379582 1.36822C0.0866888 1.07533 0.0866888 0.600454 0.379582 0.307561Z" fill="#E71E8C"/></svg></div>', 
    			autoplay: false,
                infinite: true,
    			autoplaySpeed: 3000,
            responsive: [
                    {
                      breakpoint: 1200,
                      settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                      }
                    },
                {
                      breakpoint: 768,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                      }
                    },
                {
                      breakpoint: 480,
                      settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                      }
                    }
              ]
            });

 }

$(window).load(function() {
 
    // equalheight('.product_slider_home .card__information h3');
setTimeout(function(){
  $(".slider_change_img").click(function() {
   
    $('.video_fullwidth').trigger('pause');
});
},1000)

});


$(window).resize(function(){
     // equalheight('.product_slider_home .card__information h3');
});




equalheight = function(container){

var currentTallest = 0,
     currentRowStart = 0,
     rowDivs = new Array(),
     $el,
     topPosition = 0;
 $(container).each(function() {

   $el = $(this);
   $($el).height('auto')
   topPostion = $el.position().top;

   if (currentRowStart != topPostion) {
     for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
       rowDivs[currentDiv].height(currentTallest);
     }
     rowDivs.length = 0; // empty the array
     currentRowStart = topPostion;
     currentTallest = $el.height();
     rowDivs.push($el);
   } else {
     rowDivs.push($el);
     currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
  }
   for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
     rowDivs[currentDiv].height(currentTallest);
   }
 });
}



